/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 16:59:14
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-09-06 10:03:48
 * @FilePath: /unifyxp-v2-store-portal/src/config/SiderConfig/SalesChannelVersionSiderConfig.tsx
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';
import { Icon } from '@/src/tools/icon';
import NameWithErr from 'src/constrains/SiderErrorController/SiderNameWithErr';
import { EnumSider, EnumSiderEvent } from 'src/types/common/sider';
import { updateSalesChannel } from 'src/constrains/SiderErrorController/tools';
import { cancelAllRequests } from 'src/tools/server';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { ChannelType } from 'src/types/common/SalesChannel';
import { get } from 'lodash';
import { EPermissionSource } from 'src/types/common/resources';

import {
  salesChannelVersionList,
  salesChannelProductParent,
  salesChannelProductsList,
  salesChannelPromotionTagList,
  salesChannelMaintenance,
  salesChannelCollection,
  salesChannelCategory,
  salesChannelLegalParent,
  salesChannelLegalList,
  salesChannelTCList,
  salesChannelPromotion,
  salesChannelSetting,
} from 'src/tools/permissions/salesChannelSiderPermissions';
import { salesChannelDict } from 'src/tools/urlMap';
import { getI18nFromGeneral } from 'src/tools/tools';

export const menuArray = (params) => {
  const uuid = get(params, 'uuid');
  const type = useSalesChannelType();
  const isMini = type === ChannelType.MiniProgram;
  const update = (forceUpdate) => {
    updateSalesChannel({ uuid, forceUpdate });
  };
  const _update = () => {
    update(true);
  };
  React.useEffect(() => {
    _update();
    window.addEventListener(EnumSiderEvent.salesChannel, _update);
    return () => {
      cancelAllRequests();
      window.removeEventListener(EnumSiderEvent.salesChannel, _update);
    };
  }, []);
  const _name = (name) => [uuid, name];
  return [
    {
      path: '/salesChannels',
      iconType: <Icon type='iconleft2' className={'global__icon'} />,
      name: getI18nFromGeneral('general.sider.goBack'),
      key: 'salesChannelGoBack',
      routers: [],
    },

    {
      path: `/salesChannel/content/${uuid}`,
      iconType: <Icon type='iconcontent1' className={'global__icon'} />,
      name: (
        <NameWithErr
          name={getI18nFromGeneral('general.sider.content')}
          id={_name(EnumSider.Content)}
        />
      ),
      key: 'salesChannelContent',
      routers: salesChannelDict.salesChannelContent, //['/salesChannel/content/*'],
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelVersionList(params, uuid),
    },
    {
      // path: `/salesChannel/legal/${uuid}`,
      iconType: <Icon type='iconproducts' className={'global__icon'} />,
      name: getI18nFromGeneral('general.sider.products'),
      key: 'salesChannelProducts',
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelProductParent(params, uuid),
      sub: [
        {
          path: `/salesChannel/products/${uuid}`,
          iconType: undefined,
          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.productsList')}
              id={_name(EnumSider.Products)}
            />
          ),
          key: 'salesChannelProducts-sub',
          routers: salesChannelDict.productList, //['/salesChannel/products/*'],
          source: EPermissionSource.salesChannel,
          permissionGroup: salesChannelProductsList(params, uuid),
        },
        {
          path: `/salesChannel/promotionTagList/${uuid}`,
          iconType: undefined,
          name: getI18nFromGeneral('general.sider.promotionTag'),
          key: 'salesChannelPromotionTagList-sub',
          routers: salesChannelDict.promotionTag, //
          // [
          //   '/salesChannel/promotionTag/editor/*/*',
          //   '/salesChannel/promotionTagList/*',
          // ],
          source: EPermissionSource.salesChannel,
          permissionGroup: salesChannelPromotionTagList(params),
        },
      ],
    },
    {
      path: `/salesChannel/maintenance/${uuid}`,
      iconType: <Icon type='iconmaintancepage' className={'global__icon'} />,
      name: (
        <NameWithErr
          name={getI18nFromGeneral('general.sider.maintenance')}
          id={_name(EnumSider.MaintenancePage)}
        />
      ),
      key: 'maintenance',
      routers: salesChannelDict.maintenance, //['/salesChannel/maintenance/*'],
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelMaintenance(params),
    },
    {
      path: `/salesChannel/collections/list/${uuid}`,
      iconType: <Icon type='iconcollection' className={'global__icon'} />,
      name: (
        <NameWithErr
          name={getI18nFromGeneral('general.sider.collection')}
          id={_name(EnumSider.productCollection)}
        />
      ),
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelCollection(params),
      key: 'productCollection',
      routers: salesChannelDict.collection,
      //  [
      //   '/salesChannel/collections/list/*',
      //   '/salesChannel/collections/editor/*/*',
      // ],
    },
    ...(isMini
      ? []
      : [
          {
            // path: `/salesChannel/legal/${uuid}`,
            iconType: <Icon type='iconcategory' className={'global__icon'} />,
            name: getI18nFromGeneral('general.sider.category'),
            key: 'salesChannelCategory',
            source: EPermissionSource.salesChannel,
            permissionGroup: salesChannelCategory(params),
            sub: [
              {
                path: `/salesChannel/category/products/${uuid}`,
                name: getI18nFromGeneral('general.sider.products'),
                key: 'salesChannelCategoryProducts',
                iconType: undefined,
                source: EPermissionSource.salesChannel,
                permissionGroup: salesChannelCategory(params),
                routers: salesChannelDict.categoryProduct, // ['/salesChannel/category/products/*'],
              },
              {
                path: `/salesChannel/category/pages/${uuid}`,
                name: getI18nFromGeneral('general.sider.pages'),
                key: 'salesChannelCategoryPages',
                iconType: undefined,
                source: EPermissionSource.salesChannel,
                permissionGroup: salesChannelCategory(params),
                routers: salesChannelDict.categoryPage, //['/salesChannel/category/pages/*'],
              },
            ],
          },
        ]),

    {
      // path: `/salesChannel/legal/${uuid}`,
      iconType: <Icon type='iconlegal' className={'global__icon'} />,
      name: getI18nFromGeneral('general.sider.legal'),
      key: 'salesChannelLegal',
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelLegalParent(params),
      sub: [
        {
          path: `/salesChannel/legalPage/list/${uuid}`,
          name: getI18nFromGeneral('general.sider.legalPage'),
          key: 'SalesChannelLegalPage',
          iconType: undefined,
          routers: salesChannelDict.legalPage,
          //  [
          //   '/salesChannel/legalPage/list/*',
          //   '/salesChannel/legalPage/editor/*/*',
          // ],
          source: EPermissionSource.salesChannel,
          permissionGroup: salesChannelLegalList(params),
        },
        {
          path: `/salesChannel/termsAndCondition/list/${uuid}`,
          name: getI18nFromGeneral('general.sider.terms'),
          key: 'Terms&Conditions',
          iconType: undefined,
          routers: salesChannelDict.tc,
          // [
          //   '/salesChannel/termsAndCondition/list/*',
          //   '/salesChannel/termsAndCondition/editor/*/*',
          // ],
          source: EPermissionSource.salesChannel,
          permissionGroup: salesChannelTCList(params),
        },
      ],
    },
    {
      // path: `/salesChannel/legal/${uuid}`,
      iconType: <Icon type='iconpromotion' className={'global__icon'} />,
      name: getI18nFromGeneral('general.sider.discounts'),
      key: 'discounts',
      source: EPermissionSource.salesChannel,
      permissionGroup: salesChannelPromotion(params),
      sub: [
        {
          path: `/salesChannel/discounts/directDiscount/list/${uuid}`,
          name: (
            <NameWithErr
              name={getI18nFromGeneral('general.sider.directDiscounts')}
              id={_name(EnumSider.SalesChannelDiscountsDirectDiscount)}
            />
          ),
          key: 'SalesChannelDiscountsDirectDiscount',
          iconType: undefined,
          routers: salesChannelDict.directDiscount,
          // [
          //   '/salesChannel/discounts/directDiscount/editor/*/*',
          //   '/salesChannel/discounts/directDiscount/list/*',
          // ],
          permissionGroup: salesChannelPromotion(params),
        },
        ...(isMini
          ? []
          : [
              {
                path: `/salesChannel/discounts/subscriptionBuy/list/${uuid}`,
                name: (
                  <NameWithErr
                    name={getI18nFromGeneral('general.sider.subscriptionBuy')}
                    id={_name(EnumSider.SalesChannelDiscountsSubscriptionBuy)}
                  />
                ),
                key: 'SalesChannelDiscountsSubscriptionBuy',
                iconType: undefined,
                routers: salesChannelDict.subscriptionBuy,
                // [
                //   '/salesChannel/discounts/subscriptionBuy/editor/*/*',
                //   '/salesChannel/discounts/subscriptionBuy/list/*',
                // ],
                permissionGroup: salesChannelPromotion(params),
              },
            ]),

        {
          path: `/salesChannel/discounts/giftPurchase/list/${uuid}`,
          name: getI18nFromGeneral('general.sider.giftPurchase'),
          key: 'SalesChannelDiscountsGiftPurchase',
          iconType: undefined,
          routers: salesChannelDict.giftPurchase,
          // [
          //   '/salesChannel/discounts/giftPurchase/editor/*/*',
          //   '/salesChannel/discounts/giftPurchase/list/*',
          // ],
          permissionGroup: salesChannelPromotion(params),
        },
        {
          path: `/salesChannel/discounts/flashSale/list/${uuid}`,
          name: getI18nFromGeneral('general.sider.flashSale'),
          key: 'SalesChannelDiscountsFlashSale',
          iconType: undefined,
          routers: salesChannelDict.flashSale,
          // [
          //   '/salesChannel/discounts/flashSale/editor/*/*',
          //   '/salesChannel/discounts/flashSale/list/*',
          // ],
          permissionGroup: salesChannelPromotion(params),
        },
        {
          path: `/salesChannel/discounts/voucher/list/${uuid}`,
          name: getI18nFromGeneral('general.sider.voucher'),
          key: 'SalesChannelDiscountsVoucher',
          iconType: undefined,
          routers: salesChannelDict.voucher,
          //  [
          //   '/salesChannel/discounts/voucher/editor/*/*',
          //   '/salesChannel/discounts/voucher/list/*',
          // ],
          permissionGroup: salesChannelPromotion(params),
        },
      ],
    },
    {
      // path: `/salesChannel/legal/${uuid}`,
      iconType: <Icon type='iconsettings' className={'global__icon'} />,
      name: getI18nFromGeneral('general.sider.settings'),
      key: 'salesChannelSetting',
      path: `/salesChannel/settings/${uuid}`,
      routers: salesChannelDict.settings, // ['/salesChannel/setting/*/*', '/salesChannel/settings/*'],
      permissionGroup: salesChannelSetting(params),
      // sub: [
      //   {
      //     path: `/salesChannel/settings/${uuid}`,
      //     name: 'Legal Page',
      //     key: 'SalesChannelSettings',
      //     iconType: undefined,
      //     routers: ['/salesChannel/settings/*'],
      //   },
      // ],
    },
  ];
};
